<template>
  <div class="mainContainer">
    <div class="waitContain" v-if="enterpriseData.status != 2">
      <div class="textContain">
        <div class="title">企业号</div>
        <div class="label">功能说明</div>
        <div class="intro">
          企业号是企业/商家在顶端做生意的一站式经营平台。为企业/商家提供蓝V标识、用户洞察、粉丝触达、转化工具、培训指导等，服务企业更好地经营用户，通过持续经营深化企业与用户的关系，从而实现品牌、销量等商业价值的持续成长。
        </div>
        <div class="label">开通条件</div>
        <div class="intro">
          在顶端新闻APP【我的】页面【申请认证】，完成企业认证，联系客服或者相关业务人员开通企业会员。
        </div>
        <div class="addBtn" @click="authenticationVisible = true">立即申请</div>
      </div>
      <img src="../../assets/govAffairs/enterprise.png" class="exampleImg" />

      <el-dialog
        title=""
        :visible.sync="contactVisible"
        width="420px"
        class="contactContainer"
      >
        <img src="../../assets/govAffairs/contact.png" class="contactImg" />
        <div class="contactText">您的专属政务客服</div>
        <div class="contactText">
          <div class="contactLabel">联系方式：</div>
          <div class="contactTels">
            18237108378<br />18625523656<br />15516926071
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <div class="submitBtn" @click="contactVisible = false">取 消</div>
          <div class="submitBtn" type="primary" @click="contactVisible = false">
            确 定
          </div>
        </div>
      </el-dialog>
    </div>

    <div class="setContain" v-else>
      <el-tabs v-model="activeName">
        <el-tab-pane label="企业信息" name="first">
          <div class="userInfoContain">
            <div class="userInfoNavContain">
              <div
                class="userInfoNav"
                :class="{ userInfoActive: infoTypeIndex == 0 }"
                @click="infoTypeIndex = 0"
              >
                基本信息
              </div>
              <div
                class="userInfoNav"
                :class="{ userInfoActive: infoTypeIndex == 1 }"
                @click="infoTypeIndex = 1"
              >
                主页信息
              </div>
            </div>
            <div class="userBaseInfoContain" v-if="infoTypeIndex == 0">
              <div class="userInfoTitleContain">
                <p class="userInfoTitle">企业昵称：</p>
                <p class="userInfoMore" @click="showNameAlert()">查看规范</p>
              </div>
              <el-input
                placeholder="请输入企业昵称"
                v-model="enterpriseData.audit_nickname"
                maxlength="30"
                :disabled="true"
                v-if="enterpriseData.audit_nickname != ''"
              >
              </el-input>
              <el-input
                placeholder="请输入企业昵称"
                v-model="enterpriseData.u_nickname"
                maxlength="30"
                v-else
              >
              </el-input>
              <div class="userInfoAlert">
                字数30字以内，昵称与认证主体名称相关。例：企业全称、关键字
              </div>
              <div class="userInfoTitleContain">
                <p class="userInfoTitle">企业LOGO：</p>
              </div>
              <div class="userLogoContain">
                <el-upload
                  drag
                  action="no"
                  accept="image/*"
                  :before-upload="onBeforeUpload"
                  :http-request="uploadFn"
                  class="uploadElemBox"
                >
                  <img
                    :src="
                      enterpriseData.audit_avatar || enterpriseData.u_avatar
                    "
                    class="userLogo"
                  />
                </el-upload>
              </div>
              <div class="userInfoAlert">
                仅支持jpg、png、jpeg格式图片，图片尺寸1:1，大小不能大于2M
              </div>
              <div class="userInfoTitleContain">
                <p class="userInfoTitle">企业简介：</p>
              </div>
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入企业简介"
                v-model="enterpriseData.audit_description"
                resize="none"
                maxlength="200"
                show-word-limit
                :autosize="true"
                :disabled="true"
                v-if="enterpriseData.audit_description != ''"
              >
              </el-input>
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入企业简介"
                v-model="enterpriseData.description"
                resize="none"
                maxlength="200"
                show-word-limit
                :autosize="true"
                v-else
              >
              </el-input>

              <div
                class="userInfoExamineContain"
                v-if="
                  enterpriseData.audit_avatar != '' &&
                  enterpriseData.audit_description != '' &&
                  enterpriseData.audit_nickname != ''
                "
              >
                <div class="userInfoExamineTitle">审核中</div>
                <!-- <div class="userInfoExaminecancel">取消修改</div> -->
              </div>
              <div class="userInfoSubmitBtn" @click="submitUserInfo()" v-else>
                保存
              </div>
            </div>
            <div class="userHomeInfoContain" v-if="infoTypeIndex == 1">
              <div class="userHomeInfoAlert">
                温馨提示：打开右侧按钮，此条信息可对外展示
              </div>
              <div class="userInfoTitleContain">
                <p class="userInfoTitle">官方网站：</p>
              </div>
              <div class="userHomeInfoEditContain">
                <el-input
                  placeholder="请输入官方网站"
                  v-model="enterpriseData.showinfo.official_website"
                  maxlength="100"
                  :disabled="enterpriseData.showinfo_audit_status == 0"
                >
                </el-input>
                <el-switch
                  v-model="enterpriseData.showinfo.official_website_show"
                  active-color="#F62F32"
                  inactive-color="#F5F5F5"
                  :disabled="enterpriseData.showinfo_audit_status == 0"
                >
                </el-switch>
              </div>
              <div class="userInfoTitleContain">
                <p class="userInfoTitle">查看地址：</p>
              </div>
              <MapSelection
                ref="mapSelection"
                @confirm="handleLocationSelected"
                :enterpriseData="enterpriseData"
              />
              <div class="userHomeInfoEditContain">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入地址"
                  v-model="enterpriseData.showinfo.address"
                  resize="none"
                  maxlength="200"
                  show-word-limit
                  :autosize="true"
                  :disabled="enterpriseData.showinfo_audit_status == 0"
                >
                </el-input>
                <el-switch
                  v-model="enterpriseData.showinfo.address_show"
                  active-color="#F62F32"
                  inactive-color="#F5F5F5"
                  :disabled="enterpriseData.showinfo_audit_status == 0"
                >
                </el-switch>
              </div>
              <div class="userInfoTitleContain">
                <p class="userInfoTitle">联系电话：</p>
              </div>
              <div class="userHomeInfoEditContain">
                <el-input
                  placeholder="请输入联系电话"
                  v-model="enterpriseData.showinfo.phone"
                  maxlength="50"
                  :disabled="enterpriseData.showinfo_audit_status == 0"
                >
                </el-input>
                <el-switch
                  v-model="enterpriseData.showinfo.phone_show"
                  active-color="#F62F32"
                  inactive-color="#F5F5F5"
                  :disabled="enterpriseData.showinfo_audit_status == 0"
                >
                </el-switch>
              </div>
              <div class="userInfoTitleContain">
                <p class="userInfoTitle">营业时间：</p>
              </div>
              <div class="userHomeInfoEditContain">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入营业时间"
                  v-model="enterpriseData.showinfo.open_hours"
                  resize="none"
                  maxlength="200"
                  show-word-limit
                  :autosize="true"
                  :disabled="enterpriseData.showinfo_audit_status == 0"
                >
                </el-input>
                <el-switch
                  v-model="enterpriseData.showinfo.open_hours_show"
                  active-color="#F62F32"
                  inactive-color="#F5F5F5"
                  :disabled="enterpriseData.showinfo_audit_status == 0"
                >
                </el-switch>
              </div>
              <div class="userInfoTitleContain">
                <p class="userInfoTitle">品牌封面图：</p>
              </div>
              <div class="homeBgContain">
                <el-upload
                  drag
                  action="no"
                  accept="image/*"
                  :before-upload="onBeforeUpload"
                  :http-request="uploadFn"
                  class="uploadElemBox"
                >
                  <img
                    :src="
                      enterpriseData.showinfo.cover_url ||
                      require('../../assets/script/uploadC.png')
                    "
                    class="homeBg"
                  />
                </el-upload>
                <img
                  src="../../assets/imgDelete.png"
                  class="imgDelete"
                  @click="imgDelete()"
                />
              </div>
              <div class="homeBgAlert">
                此图主要用于企业品牌搜索结果的展示
                <br />仅支持jpg、png、jpeg格式图片，图片尺寸16:9
                大小不能大于5M。
              </div>
              <div class="userInfoTitleContain" style="display: block">
                <p class="userInfoTitle">搜索关键词：</p>
                <div class="userInfoAlert">
                  配置搜索关键词，方便用户按关键词搜索到企业，字数要求8个字以内
                </div>
              </div>
              <div class="searchKeyContain">
                <div
                  class="searchInputContain"
                  v-for="(item, index) in searchKeyList"
                  :key="index"
                >
                  <img
                    src="../../assets/govAffairs/jian.png"
                    class="keyIcon"
                    @click="removeKey(index)"
                  />
                  <el-input
                    placeholder="请输入关键词"
                    v-model="searchKeyList[index]"
                    maxlength="8"
                    :disabled="enterpriseData.showinfo_audit_status == 0"
                  >
                  </el-input>
                </div>
                <div
                  class="searchInputContain"
                  @click="addKey()"
                  style="cursor: pointer"
                  v-if="
                    searchKeyList.length < 5 &&
                    enterpriseData.showinfo_audit_status != 0
                  "
                >
                  <img src="../../assets/govAffairs/jia.png" class="keyIcon" />
                  <p class="keyText">
                    添加关键词({{ searchKeyList.length }}/5)
                  </p>
                </div>
              </div>

              <div
                class="userInfoSubmitBtn"
                @click="submitUserInfo()"
                v-if="enterpriseData.showinfo_audit_status != 0"
              >
                保存
              </div>
              <div class="userInfoExamineContain" v-else>
                <div class="userInfoExamineTitle">审核中</div>
                <!-- <div class="userInfoExaminecancel">取消修改</div> -->
              </div>
              <div class="userInfoSubmitAlert">
                提示：请准确填写信息方便审核，开启展示功能可对外展示
              </div>
              <div
                class="userInfoExamineAlert"
                v-if="enterpriseData.showinfo_audit_status == 2"
              >
                资料内容未通过审核，请重新修改后再次提交
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="招聘管理" name="third">
          <div class="noJobContain" v-if="jobListCount == 0">
            <div class="noJobText">暂无招聘岗位，快去发布吧！</div>
            <div class="pubJobBtn" @click="addJobShow()">发布职位</div>
          </div>
          <div class="jobManageContain" v-else>
            <el-input
              :clearable="true"
              v-model="jobSearchText"
              prefix-icon="el-icon-search"
              placeholder="请输入关键词"
              @change="jobSearchChange"
            />
            <div class="jobTypeContain">
              <div
                class="jobTypeItem"
                :class="{ jobTypeActive: jobTypeIndex == index }"
                :key="index"
                v-for="(item, index) in jobTypeList"
                @click="jobTypeClick(index)"
              >
                {{ item.name }}（{{ item.count }}）
              </div>
            </div>
            <div class="jobList" v-if="jobList.length > 0">
              <div
                v-for="(item, index) in jobList"
                :key="index"
                class="jobItem"
                :class="{ jobClosed: item.status_msg == '已招满' }"
              >
                <div class="jobHeader">
                  <div class="jobFlex">
                    <div class="jobName" @click="jobDetail(item)">
                      {{ item.title }}
                    </div>
                    <div class="jobMoney">
                      <span v-if="item.low_salary">{{
                        parseInt(item.low_salary)
                      }}</span
                      ><span v-if="item.high_salary"
                        >-{{ parseInt(item.high_salary) }}</span
                      ><span>{{ item.salary_type | getSalaryName }}</span>
                    </div>
                  </div>
                  <div class="jobFlex">
                    <div
                      class="jobStatus jobStatusClosed"
                      v-if="item.status_msg == '已招满'"
                    >
                      已关闭
                    </div>
                    <div
                      class="jobStatus jobStatusFail"
                      v-if="item.status_msg.indexOf('审核未通过') > -1"
                    >
                      未通过
                    </div>
                    <div
                      class="jobStatus jobStatusIng"
                      v-if="item.status_msg == '待审核'"
                    >
                      审核中
                    </div>
                    <div class="jobStatus" v-if="item.status_msg == '正在招'">
                      正在招
                    </div>
                    <!-- <div class="jobTime">更新于：{{ item.update_time }}</div> -->
                  </div>
                </div>
                <div class="jobTagContain">
                  <div
                    v-for="(item1, index1) in item.tagsShow"
                    :key="index1"
                    class="jobTag"
                  >
                    {{ item1 }}
                  </div>
                </div>
                <div class="jobFooter">
                  <div class="jobFlex">
                    <div
                      class="jobStatus jobStatusIng"
                      v-if="item.status_msg == '待审核'"
                    >
                      审核中
                    </div>
                    <div
                      class="jobStatus"
                      v-if="
                        item.status_msg == '正在招' ||
                        item.status_msg == '已招满'
                      "
                    >
                      已发布
                    </div>
                    <div
                      class="jobView"
                      v-if="
                        item.status_msg == '正在招' ||
                        item.status_msg == '已招满'
                      "
                    >
                      查看 <span class="jobViewNum">{{ item.click_num }}</span>
                    </div>
                    <div
                      class="jobReason"
                      v-if="item.status_msg.indexOf('审核未通过') > -1"
                    >
                      未通过：{{ item.audit_msg }}
                    </div>
                  </div>
                  <div class="jobFlex">
                    <div
                      class="jobBtn"
                      @click="editJob(item)"
                      v-if="
                        item.status_msg == '正在招' ||
                        item.status_msg == '已招满'
                      "
                    >
                      修改
                    </div>
                    <div
                      class="jobBtn"
                      @click="openJob(item)"
                      v-if="
                        item.status_msg == '正在招' ||
                        item.status_msg == '已招满'
                      "
                    >
                      {{ item.status_msg == "正在招" ? "关闭" : "开启" }}
                    </div>
                    <div
                      class="jobBtn"
                      @click="deleteJob(item)"
                      v-if="item.status_msg != '待审核'"
                    >
                      删除
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="noJob"
              v-else-if="jobList.length == 0 && jobSearchText != ''"
            >
              未查询到
              <span class="noJobSearch">{{ jobSearchText }}</span> 相关信息
            </div>
            <el-pagination
              background
              :current-page="jobCurrentPage"
              :page-size="jobPageSize"
              layout="total, prev, pager, next, jumper"
              :total="jobTotal"
              @current-change="handleJobCurrentChange"
              v-if="jobList.length > 0"
            />
            <div class="clear"></div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="栏目内容" name="second">
          <div class="contentSetContain">
            <div class="contentSetTitle">自定义菜单</div>
            <div class="contentSetAlert">
              最多支持创建10个自定义菜单（含默认菜单）
            </div>
            <div class="contentSetInnerContain">
              <div class="menuContain">
                <div class="addMenuBtn" @click="openMenuEdit()">
                  <img
                    src="../../assets/govAffairs/add.png"
                    class="addMenuImg"
                  />
                  <div class="addMenuText">添加快捷菜单</div>
                </div>
                <draggable
                  class="menusContain publicScroll"
                  v-model="menuList"
                  @start="onDragStart"
                  @end="onDragEnd"
                >
                  <div
                    class="menuItem"
                    v-for="(item, index) in menuList"
                    :key="index"
                    :class="{ active: menuIndex === index }"
                    @click="menuClick(index)"
                  >
                    <img
                      src="../../assets/govAffairs/setR.png"
                      class="setImg"
                      v-if="menuIndex == index"
                    />
                    <img
                      src="../../assets/govAffairs/set.png"
                      class="setImg"
                      v-else
                    />
                    <div class="menuName">{{ item.name }}</div>
                    <div class="menuEditBtn" @click.stop="openMenuEdit(item)">
                      编辑
                    </div>
                    <div
                      class="menuDelBtn"
                      :class="{ acytiveText: menuIndex == index }"
                      @click.stop="delGovernmentMenu(index)"
                    >
                      删除
                    </div>
                  </div>
                </draggable>
              </div>
              <div class="menuContentContain" v-if="menuList.length">
                <div class="menuContentTitleContain">
                  <div class="menuContentTitle">
                    菜单类型：{{ menuList[menuIndex].jump_type | getTypeName }}
                  </div>
                  <div
                    class="addNewsBtn"
                    v-if="menuList[menuIndex].jump_type == 1"
                    @click="openVideos()"
                  >
                    <img
                      src="../../assets/govAffairs/add.png"
                      class="addNewsImg"
                    />
                    <div class="addNewsText">添加稿件</div>
                  </div>
                </div>
                <div
                  class="paramsContain"
                  v-show="menuList[menuIndex].jump_type > 1"
                >
                  <div class="paramInfo">
                    <span class="paramInfoLabel">跳转地址：</span
                    >{{ menuList[menuIndex].jump_params.jump_id }}
                  </div>
                  <div
                    class="paramInfo"
                    v-if="menuList[menuIndex].jump_params.jump_app_id"
                  >
                    <span class="paramInfoLabel">APP ID：</span
                    >{{ menuList[menuIndex].jump_params.jump_app_id }}
                  </div>
                  <div
                    class="paramInfo"
                    v-if="menuList[menuIndex].jump_params.jump_app_query"
                  >
                    <span class="paramInfoLabel">QUERY：</span
                    >{{ menuList[menuIndex].jump_params.jump_app_query }}
                  </div>
                </div>
                <draggable
                  class="newsContain publicScroll"
                  v-model="collectionList"
                  @end="onNewsDragEnd"
                  v-show="menuList[menuIndex].jump_type == 1"
                >
                  <div
                    class="newsItem"
                    v-for="(item, index) in collectionList"
                    :key="index"
                  >
                    <img
                      src="../../assets/govAffairs/shift.png"
                      class="shiftImg"
                    />
                    <div class="bgContainer">
                      <div
                        class="cover-container"
                        v-if="item.n_cover_url.length > 0"
                      >
                        <el-image
                          class="cover"
                          fit="cover"
                          :src="item.n_cover_url[0]"
                          :preview-src-list="item.n_cover_url"
                        />
                      </div>
                      <div class="info-box">
                        <div class="titleContainer">
                          <p class="title">
                            {{ item.n_title }}
                          </p>
                          <p class="create-time">{{ item.n_create_time }}</p>
                        </div>
                        <div class="action-bar">
                          <!-- <div class="countInfo">展现 {{ item.watch_num }}</div>
                      <div class="countInfo">评论 {{ item.comment_num }}</div> -->
                          <div
                            class="menuNewsDelBtn"
                            @click="delMenuNews(index)"
                          >
                            删除
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </draggable>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>

      <div
        class="openJobBtn"
        v-if="jobListCount > 0 && activeName == 'third'"
        @click="addJobShow()"
      >
        发布职位
      </div>

      <el-dialog
        :title="(editMenuObj.id ? '编辑' : '添加') + '快捷菜单'"
        :visible.sync="editMenuVisible"
        width="840px"
        class="editMenuContainer"
      >
        <div class="editMenuInnerContain">
          <div class="editItem">
            <div class="label"><span class="require">*</span>名称：</div>
            <el-input
              placeholder="请输入菜单名称"
              v-model="editMenuObj.name"
              maxlength="10"
            >
            </el-input>
          </div>
          <div class="editItem">
            <div class="label"><span class="require">*</span>菜单类型：</div>
            <el-radio-group v-model="editMenuObj.jump_type">
              <el-radio :label="1">稿件列表</el-radio>
              <el-radio :label="2">跳转网页</el-radio>
              <el-radio :label="3">跳转微信小程序</el-radio>
              <el-radio :label="4">跳转支付宝小程序</el-radio>
            </el-radio-group>
          </div>
          <div class="editItem" v-if="editMenuObj.jump_type > 1">
            <div class="label"><span class="require">*</span>跳转地址：</div>
            <el-input placeholder="请输入" v-model="editMenuObj.jump_id">
            </el-input>
          </div>
          <div class="editItem" v-if="editMenuObj.jump_type > 2">
            <div class="label"><span class="require">*</span>APP ID：</div>
            <el-input placeholder="请输入" v-model="editMenuObj.jump_app_id">
            </el-input>
          </div>
          <div class="editItem" v-if="editMenuObj.jump_type == 4">
            <div class="label"><span class="require">*</span>QUERY：</div>
            <el-input placeholder="请输入" v-model="editMenuObj.jump_app_query">
            </el-input>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <div class="submitBtn" @click="editMenuVisible = false">取 消</div>
          <div class="submitBtn" type="primary" @click="setGovernmentMenu()">
            确 定
          </div>
        </div>
      </el-dialog>

      <el-dialog
        title="添加内容"
        :visible.sync="collectionAddVisible"
        width="840px"
        top="5vh"
        class="collectionAddContainer"
        :close-on-click-modal="false"
      >
        <el-input
          v-model="collectionAddKeyword"
          placeholder="请输入关键词"
          clearable
          class="collectionAddKeyword"
          @keyup.enter.native="getVideoList(1)"
          @clear="clearVideoList()"
        ></el-input>
        <el-button type="primary" @click="getVideoList(1)">查 询</el-button>
        <div
          class="videoCollectContainer publicScroll"
          v-show="collectionAddList.length"
        >
          <div
            v-for="(item, index) in collectionAddList"
            :key="index"
            class="scriptListItem"
          >
            <el-checkbox
              v-model="item.checked"
              @change="(checked) => handleCheckVideo(checked, item)"
            ></el-checkbox>
            <div class="bgContainer">
              <div class="cover-container" v-if="item.n_cover_url.length > 0">
                <el-image
                  class="cover"
                  fit="cover"
                  :src="item.n_cover_url[0]"
                  :preview-src-list="item.n_cover_url"
                />
              </div>
              <div class="info-box">
                <div class="titleContainer">
                  <p class="title" @click="toDetail(item)">
                    {{ item.n_title }}
                  </p>
                  <p class="create-time">{{ item.n_create_time }}</p>
                </div>
                <div class="action-bar">
                  <div class="countInfo">展现 {{ item.watch_num }}</div>
                  <div class="countInfo">评论 {{ item.comment_num }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="searchNoDataContainer" v-if="collectionAddList.length == 0">
          <img src="../../assets/script/no.png" class="noDataImg" />
          <p class="noDataText">暂无数据</p>
        </div>
        <el-pagination
          background
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
          @current-change="handleCurrentChange"
        />
        <br />
        <div slot="footer" class="dialog-footer">
          <el-button @click="collectionAddVisible = false">取 消</el-button>
          <el-button type="primary" @click="addVideosFn">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <el-dialog
      :title="authenticationTitle"
      :visible.sync="authenticationVisible"
      width="1026px"
      class="authenticationContainer"
    >
      <div class="authenticationIntro" v-html="authenticationIntro"></div>
      <div class="imgStepContain">
        <div
          class="noAuthenticationContain"
          v-if="enterpriseData.user_cert_info.user_cert_type === ''"
        >
          <div style="width: 50%">
            <div class="authenticationStepTitle">1、打开“顶端新闻”App</div>
            <div class="authenticationStepIntro">
              登录当前账号或扫下方二维码下载“顶端新闻”App
            </div>
            <img
              src="../../assets/govAffairs/enterprise1.png"
              class="authenticationStepImg"
              style="width: 118px; margin: 42px 0 0 105px; display: block"
            />
          </div>
          <div style="width: 50%">
            <div class="authenticationStepTitle">2、打开“我的”</div>
            <div class="authenticationStepIntro">
              点击“申请认证”完成企业认证
            </div>
            <img
              src="../../assets/govAffairs/enterprise2.png"
              class="authenticationStepImg"
              style="width: 254px; margin: 22px 0 0 42px; display: block"
            />
          </div>
        </div>
        <div>
          <div class="authenticationStepTitle">
            <span v-if="enterpriseData.user_cert_info.user_cert_type === ''"
              >3、</span
            >打开“企业号”
          </div>
          <div class="authenticationStepIntro">
            在【我的】界面，点击左上角菜单栏，再点击【企业号】进入企业会员页面，提交开通申请
          </div>
          <img
            src="../../assets/govAffairs/enterprise3.png"
            class="authenticationStepImg"
            style="margin-top: 51px"
          />
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="jogDialogVisible"
      top="5vh"
      :center="true"
      width="450px"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      class="jobEditContain"
    >
      <iframe
        id="jobEditIframe"
        src=""
        allow="geolocation;accelerometer;gyroscope"
        style="height: 85vh; width: 400px"
      />
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { NEWS_HOST, SWNEWS_HOST, RECRUIT_HOST } from "../../constants/apiHosts";
import { HS_upload } from "./../../utils/huoshanUpload";
import MapSelection from "../../components/MapSelection/index.vue";

export default {
  data() {
    return {
      enterpriseDataOld: {},
      enterpriseData: {
        user_cert_info: {},
      },
      activeName: "first",
      contactVisible: false,
      infoTypeIndex: 0,
      menuList: [],
      menuIndex: 0,
      idNow: "",
      editMenuObj: {
        name: "",
        jump_type: 1, //1稿件 2外链 3微信小程序 4支付宝小程序
        jump_id: "", //地址
        jump_app_id: "",
        jump_app_query: "", //支付宝小程序
        id: "",
      },
      editMenuVisible: false,
      collectionList: [],
      collectionAddVisible: false,
      collectionAddList: [],
      pageSize: 20,
      currentPage: 1,
      total: 1,
      collectionAddKeyword: "",
      currentAddKeyword: "",
      collectionAddChecks: [],
      menuNewsPage: 1,
      menuNewsSize: 10,
      menuNewsIsAll: false,
      authenticationVisible: false,
      authenticationTitle: "",
      authenticationIntro: "",
      jobSearchText: "",
      jobTypeIndex: 0,
      jobTypeList: [
        {
          name: "全职",
          count: 0,
        },
        {
          name: "零工",
          count: 0,
        },
      ],
      jobListCount: 0,
      jobCurrentPage: 1,
      jobPageSize: 10,
      jobTotal: 0,
      jobList: [],
      jogDialogVisible: false,
      searchKeyList: [],
    };
  },
  components: {
    draggable,
    MapSelection,
  },
  filters: {
    getTypeName: function (type) {
      let text = "稿件列表";
      switch (type) {
        case 2:
          text = "跳转网页";
          break;
        case 3:
          text = "跳转微信小程序";
          break;
        case 4:
          text = "跳转支付宝小程序";
          break;
      }
      return text;
    },
    getSalaryName: function (type) {
      let text = "";
      switch (type) {
        case 0:
          text = "面议";
          break;
        case 1:
          text = "元/日";
          break;
        case 2:
          text = "元/月";
          break;
        case 3:
          text = "元/小时";
          break;
      }
      return text;
    },
  },
  created() {
    this.getEnterpriseUser();
    this.getGovernmentMenuList();
    this.getJobList();
    this.getJobSecondCount();
  },
  mounted() {
    let _this = this;
    window.addEventListener("message", (event) => {
      if (event.data == "jobEditSuccess") {
        _this.getJobList();
        _this.jogDialogVisible = false;
      }
    });
  },
  methods: {
    getEnterpriseUser(isFresh) {
      this.$axios
        .get(`${SWNEWS_HOST}/api/enterpriseUser/index`, {})
        .then((res) => {
          if (res.data.code == 0) {
            if (isFresh) {
              this.enterpriseData.audit_avatar = res.data.data.audit_avatar;
              this.enterpriseData.audit_description =
                res.data.data.audit_description;
              this.enterpriseData.audit_nickname = res.data.data.audit_nickname;
              this.enterpriseData.u_avatar = res.data.data.u_avatar;
              this.enterpriseData.description = res.data.data.description;
              this.enterpriseData.u_nickname = res.data.data.u_nickname;
              return;
            }
            this.enterpriseData = res.data.data;
            if (this.enterpriseData.audit_showinfo.address) {
              this.enterpriseData.showinfo = {
                ...this.enterpriseData.audit_showinfo,
              };
            }
            if (
              this.enterpriseData.audit_showinfo.search_keyword &&
              this.enterpriseData.audit_showinfo.search_keyword.length
            ) {
              this.searchKeyList = JSON.parse(
                JSON.stringify(
                  this.enterpriseData.audit_showinfo.search_keyword
                )
              );
            } else if (
              this.enterpriseData.showinfo.search_keyword &&
              this.enterpriseData.showinfo.search_keyword.length
            ) {
              this.searchKeyList = JSON.parse(
                JSON.stringify(this.enterpriseData.showinfo.search_keyword)
              );
            }
            this.enterpriseDataOld = JSON.parse(JSON.stringify(res.data.data));
            if (this.enterpriseData.user_cert_info.user_cert_type === "") {
              this.authenticationTitle = "请完成企业号认证";
              this.authenticationIntro =
                "未查询到您的认证信息，请完成企业认证后，在顶端新闻APP【我的】界面左上角菜单栏中的【企业号】中提交申请";
            } else if (
              this.enterpriseData.user_cert_info.user_cert_type != 24
            ) {
              this.authenticationTitle = "非企业认证";
              this.authenticationIntro =
                "您的认证信息与企业号认证要求不符，请联系专属客服（19513349522）重置认证<br>完成企业认证后，在【我的】界面左上角菜单栏中的【企业号】中提交申请";
            } else if (this.enterpriseData.status != 2) {
              this.authenticationTitle = "完成企业认证";
              this.authenticationIntro =
                "请打开顶端新闻APP，在【我的】界面左上角菜单栏中的【企业号】中提交申请，专属客服：19513349522";
            }

            this.$nextTick(() => {
              let _this = this;
              setTimeout(() => {
                let newsContain =
                  document.getElementsByClassName("newsContain")[0];
                if (!newsContain) {
                  return;
                }
                newsContain.addEventListener("scroll", function () {
                  if (
                    newsContain.scrollTop + newsContain.clientHeight >=
                      newsContain.scrollHeight &&
                    !_this.menuNewsIsAll &&
                    newsContain.scrollTop > 0
                  ) {
                    _this.menuNewsPage++;
                    _this.getMenuNewsList();
                  }
                });
              }, 500);
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getGovernmentMenuList() {
      this.$axios
        .post(`${SWNEWS_HOST}/api/government/getGovernmentMenuList`, {})
        .then((res) => {
          if (res.data.code == 0) {
            this.menuList = res.data.data;

            if (
              this.menuList[this.menuIndex] &&
              this.menuList[this.menuIndex].jump_type == 1
            ) {
              this.collectionList = [];
              this.menuNewsPage = 1;
              this.menuNewsIsAll = false;
              this.getMenuNewsList();
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    onDragStart() {
      this.idNow = this.menuList[this.menuIndex].id;
    },
    onDragEnd(event) {
      const { newIndex, oldIndex } = event;
      const movedItem = this.menuList[newIndex];
      const params = {
        id: movedItem.id,
        prev_id:
          newIndex > 0
            ? this.menuList[newIndex - 1]
              ? this.menuList[newIndex - 1].id
              : ""
            : "",
        next_id:
          newIndex < this.menuList.length - 1
            ? this.menuList[newIndex + 1]
              ? this.menuList[newIndex + 1].id
              : ""
            : "",
      };

      this.$axios
        .post(`${SWNEWS_HOST}/api/government/sortGovernmentMenu`, params)
        .then((res) => {
          if (res.data.code == 0) {
            this.$message({
              type: "success",
              message: "排序成功!",
            });

            this.menuIndex = this.menuList.findIndex(
              (item) => item.id == this.idNow
            );
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    menuClick(index) {
      this.menuIndex = index;

      this.collectionList = [];
      this.menuNewsPage = 1;
      this.menuNewsIsAll = false;

      if (this.menuList[index].jump_type == 1) {
        this.getMenuNewsList();
      }
    },
    openMenuEdit(editMenuObj) {
      if (editMenuObj) {
        this.editMenuObj = {
          name: editMenuObj.name,
          jump_type: editMenuObj.jump_type, //1稿件 2外链 3微信小程序 4支付宝小程序
          jump_id: editMenuObj.jump_params.jump_id, //地址
          jump_app_id: editMenuObj.jump_params.jump_app_id,
          jump_app_query: editMenuObj.jump_params.jump_app_query, //支付宝小程序
          id: editMenuObj.id,
        };
      } else if (this.menuList.length >= 10) {
        this.$message.warning("最多支持创建10个自定义菜单");
        return;
      } else {
        this.editMenuObj = {
          name: "",
          jump_type: 1, //1稿件 2外链 3微信小程序 4支付宝小程序
          jump_id: "", //地址
          jump_app_id: "",
          jump_app_query: "", //支付宝小程序
          id: "",
        };
      }
      this.editMenuVisible = true;
    },
    setGovernmentMenu() {
      if (!this.editMenuObj.name) {
        this.$message.warning("请输入菜单名称");
        return;
      } else if (this.editMenuObj.jump_type > 1 && !this.editMenuObj.jump_id) {
        this.$message.warning("请输入跳转地址");
        return;
      } else if (
        this.editMenuObj.jump_type > 2 &&
        !this.editMenuObj.jump_app_id
      ) {
        this.$message.warning("请输入APP ID");
        return;
      } else if (
        this.editMenuObj.jump_type == 4 &&
        !this.editMenuObj.jump_app_query
      ) {
        this.$message.warning("请输入QUERY");
        return;
      }

      if (!this.editMenuObj.jump_id) {
        delete this.editMenuObj.jump_id;
      }
      if (!this.editMenuObj.jump_app_id) {
        delete this.editMenuObj.jump_app_id;
      }
      if (!this.editMenuObj.jump_app_query) {
        delete this.editMenuObj.jump_app_query;
      }
      if (!this.editMenuObj.id) {
        delete this.editMenuObj.id;
      }

      this.$axios
        .post(
          `${SWNEWS_HOST}/api/government/setGovernmentMenu`,
          this.editMenuObj
        )
        .then((res) => {
          if (res.data.code == 0) {
            this.getGovernmentMenuList();

            this.$message({
              type: "success",
              message: `${this.editMenuObj.id ? "编辑" : "添加"}成功!`,
            });
            this.editMenuVisible = false;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    delGovernmentMenu(index) {
      this.$confirm("确定要删除该菜单吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.idNow = this.menuList[this.menuIndex].id;

          this.$axios
            .post(`${SWNEWS_HOST}/api/government/delGovernmentMenu`, {
              id: this.menuList[index].id,
            })
            .then((res) => {
              if (res.data.code == 0) {
                this.menuList.splice(index, 1);

                this.menuIndex = this.menuList.findIndex(
                  (item) => item.id == this.idNow
                );
                if (this.menuIndex == -1) {
                  this.menuIndex = 0;
                }

                if (this.menuList[this.menuIndex].jump_type == 1) {
                  this.collectionList = [];
                  this.menuNewsPage = 1;
                  this.menuNewsIsAll = false;
                  this.getMenuNewsList();
                }

                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {});
    },
    getMenuNewsList() {
      this.$axios
        .post(`${SWNEWS_HOST}/api/government/getMenuNewsList`, {
          menu_id: this.menuList[this.menuIndex].id,
          page: this.menuNewsPage,
          pageSize: this.menuNewsSize,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.collectionList = this.collectionList.concat(
              res.data.data.returnData
            );

            if (res.data.data.returnData.length < this.menuNewsSize) {
              this.menuNewsIsAll = true;
            } else {
              this.menuNewsIsAll = false;
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    openVideos() {
      this.currentAddKeyword = "";
      this.collectionAddKeyword = "";
      this.currentPage = 1;
      this.collectionAddChecks = JSON.parse(
        JSON.stringify(this.collectionList)
      );
      this.getVideoList();
      this.collectionAddVisible = true;

      this.$nextTick(() => {
        document.getElementsByClassName(
          "videoCollectContainer"
        )[0].scrollTop = 0;
      });
    },
    clearVideoList() {
      this.collectionAddKeyword = "";
      this.getVideoList(1);
    },
    getVideoList(isSearch) {
      if (isSearch) {
        this.currentAddKeyword = this.collectionAddKeyword;
        this.currentPage = 1;
      }
      this.$axios
        .get(
          `${SWNEWS_HOST}/api/user/newsList?page=${this.currentPage}&size=${this.pageSize}&title=${this.currentAddKeyword}&tab=7&type=0`
        )
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.returnData.forEach((item) => {
              if (this.checkCollection(item.n_id) > -1) {
                //item.checked = true;
                item.checked = false;
              } else {
                item.checked = false;
              }
              item.indexChange = "";
              item.visible = false;
            });
            this.collectionAddList = res.data.data.returnData;
            this.total = res.data.data.count;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getVideoList();

      document.getElementsByClassName("videoCollectContainer")[0].scrollTop = 0;
    },
    handleCheckVideo(val, item) {
      if (val) {
        if (this.checkCollection(item.n_id) < 0) {
          this.collectionAddChecks.unshift(item);
        }
      } else {
        if (this.checkCollection(item.n_id) > -1) {
          this.collectionAddChecks.splice(this.checkCollection(item.n_id), 1);
        }
      }
    },
    checkCollection(itemId) {
      let itemIndex = -1;
      this.collectionAddChecks.forEach((item, index) => {
        if (item.n_id == itemId) {
          itemIndex = index;
        }
      });
      return itemIndex;
    },
    addVideosFn() {
      let n_ids = [];
      if (!this.collectionAddChecks.length) {
        return;
      } else {
        this.collectionAddChecks.forEach((item) => {
          n_ids.push(item.n_id);
        });
      }

      this.$axios
        .post(`${SWNEWS_HOST}/api/government/setMenuNews`, {
          menu_id: this.menuList[this.menuIndex].id,
          n_id: n_ids.join(","),
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.collectionList = [];
            this.menuNewsPage = 1;
            this.menuNewsIsAll = false;
            this.getMenuNewsList();

            this.$message({
              type: "success",
              message: "修改成功!",
            });

            this.collectionAddVisible = false;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    toDetail(item) {
      let routeUrl = this.$router.resolve({
        path: "/scriptDetail",
        query: {
          scriptId: item.nm_id,
          isMine: 1,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    onNewsDragEnd(event) {
      const { newIndex, oldIndex } = event;
      const movedItem = this.collectionList[newIndex];
      const params = {
        id: movedItem.id,
        prev_id:
          newIndex > 0
            ? this.collectionList[newIndex - 1]
              ? this.collectionList[newIndex - 1].id
              : ""
            : "",
        next_id:
          newIndex < this.collectionList.length - 1
            ? this.collectionList[newIndex + 1]
              ? this.collectionList[newIndex + 1].id
              : ""
            : "",
      };

      this.$axios
        .post(`${SWNEWS_HOST}/api/government/sortMenuNews`, params)
        .then((res) => {
          if (res.data.code == 0) {
            this.$message({
              type: "success",
              message: "排序成功!",
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    delMenuNews(index) {
      this.$confirm("确定要删除该稿件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`${SWNEWS_HOST}/api/government/delMenuNews`, {
              id: this.collectionList[index].id,
            })
            .then((res) => {
              if (res.data.code == 0) {
                this.collectionList.splice(index, 1);

                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {});
    },
    onBeforeUpload(file) {
      if (
        (this.infoTypeIndex == 0 && this.enterpriseData.audit_avatar) ||
        (this.infoTypeIndex == 1 &&
          this.enterpriseData.showinfo_audit_status == 0)
      ) {
        this.$message.error("审核中，不可重复提交！");
        return false;
      }

      const size = this.infoTypeIndex == 0 ? 2 : 5;
      const isIMAGE = file.type.indexOf("image/") >= 0;
      const isLt1M = file.size / 1024 / 1024 < size;

      if (!isIMAGE) {
        this.$message.error("上传文件只能是图片格式！");
        return false;
      } else if (!isLt1M) {
        this.$message.error(`上传文件大小不能超过${size}MB！`);
      } else {
        return true;
      }
    },
    uploadFn(val) {
      HS_upload(
        val.file,
        (data) => {
          if (this.infoTypeIndex == 0) {
            this.enterpriseData.u_avatar = data.url;
          } else {
            this.$set(this.enterpriseData.showinfo, "cover_url", data.url);
          }
        },
        (error) => {
          console.log("error:" + error);
        },
        (processPercent) => {
          console.log("processPercent:" + processPercent);
        }
      );
    },
    submitUserInfo() {
      if (this.infoTypeIndex == 0) {
        this.$axios
          .post(`${NEWS_HOST}/api/user/edit`, {
            u_nickname:
              this.enterpriseData.audit_nickname != "" ||
              this.enterpriseData.u_nickname ==
                this.enterpriseDataOld.u_nickname
                ? ""
                : this.enterpriseData.u_nickname,
            u_avatar:
              this.enterpriseData.audit_avatar != "" ||
              this.enterpriseData.u_avatar == this.enterpriseDataOld.u_avatar
                ? ""
                : this.enterpriseData.u_avatar,
            u_description:
              this.enterpriseData.audit_description != "" ||
              this.enterpriseData.description ==
                this.enterpriseDataOld.description
                ? ""
                : this.enterpriseData.description,
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.$message({
                type: "success",
                message: "资料已提交!",
              });

              this.getEnterpriseUser(1);
            } else {
              this.$message.error(res.data.msg);
            }
          });
      } else {
        if (
          this.enterpriseData.showinfo.address_lat == "" ||
          this.enterpriseData.showinfo.address_lat == undefined
        ) {
          this.$message.error("请选择地图位置！");
          return;
        }
        this.enterpriseData.showinfo.search_keyword = this.searchKeyList
          .filter((item) => item && item.trim())
          .join(",");
        this.$axios
          .post(`${SWNEWS_HOST}/api/enterpriseUser/editInfo`, {
            ...this.enterpriseData.showinfo,
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.$message({
                type: "success",
                message: "资料已提交!",
              });

              this.enterpriseData.showinfo_audit_status = 0;
            } else {
              this.$message.error(res.data.msg);
            }
          });
      }
    },
    showNameAlert() {
      window.open(
        "https://activity.dingxinwen.com/creator/static/html/companyNickname.html"
      );
    },
    handleLocationSelected(location) {
      this.enterpriseData.showinfo.address_lat = location.lat;
      this.enterpriseData.showinfo.address_lng = location.lng;
      this.$set(
        this.enterpriseData.showinfo,
        "address",
        location.province +
          location.city +
          location.district +
          location.address +
          location.name
      );
      this.$refs.mapSelection.setLocation(null);
    },
    imgDelete() {
      if (this.enterpriseData.showinfo_audit_status == 0) {
        this.$message.error("审核中，不可修改！");
      } else {
        this.enterpriseData.showinfo.cover_url = "";
      }
    },
    addKey() {
      this.searchKeyList.push("");
    },
    removeKey(index) {
      if (this.enterpriseData.showinfo_audit_status != 0) {
        this.searchKeyList.splice(index, 1);
      }
    },
    jobTypeClick(index) {
      this.jobTypeIndex = index;
      this.jobCurrentPage = 1;
      this.getJobList();
    },
    getJobAllCount() {
      this.$axios
        .post(`${RECRUIT_HOST}/api/recruit/mylist`, {
          page: 1,
          size: 1,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.jobListCount = res.data.data.total;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getJobSecondCount() {
      this.$axios
        .post(`${RECRUIT_HOST}/api/recruit/mylist`, {
          page: 1,
          size: 1,
          type: 2,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.jobTypeList[1].count = res.data.data.total;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getJobList() {
      this.$axios
        .post(`${RECRUIT_HOST}/api/recruit/mylist`, {
          page: this.jobCurrentPage,
          size: this.jobPageSize,
          keyword: this.jobSearchText,
          type: parseInt(this.jobTypeIndex + 1),
        })
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.data.forEach((item) => {
              let tags = [];
              tags.push(
                item["location_city"] + "-" + item["location_district"]
              );
              tags.push(
                item.gender == 0 ? "性别不限" : item.gender == 1 ? "男" : "女"
              );
              tags.push(
                item.low_age != 0 && item.high_age != 0
                  ? `${item.low_age}-${item.high_age}岁`
                  : item.low_age != 0
                  ? `${item.low_age}岁以上`
                  : item.high_age != 0
                  ? `${item.high_age}岁以下`
                  : "年龄不限"
              );
              for (let i in item.tags) {
                if (this.jobTypeIndex == 1 || i != "settlement_type") {
                  for (let j in item.tags[i]) {
                    tags.push(item.tags[i][j].name);
                  }
                }
              }
              item.tagsShow = tags;
            });

            this.jobList = res.data.data.data;
            this.jobTotal = res.data.data.total;
            this.jobTypeList[this.jobTypeIndex].count = res.data.data.total;

            this.getJobAllCount();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    jobSearchChange() {
      this.jobCurrentPage = 1;
      this.getJobList();
    },
    handleJobCurrentChange(val) {
      this.jobCurrentPage = val;
      this.getJobList();
    },
    addJobShow() {
      this.jogDialogVisible = true;
      this.$nextTick(() => {
        var iframe = document.getElementById("jobEditIframe");
        iframe.src = "";
        iframe.src = `https://m.${
          window.location.href.indexOf("topnews.cn") >= 0
            ? "topnews.cn"
            : "dingnews.net"
        }/recruit-h5/index.html#/pages/post-job/index?token=${localStorage.getItem(
          "token"
        )}`;
      });
    },
    jobDetail(item) {
      this.jogDialogVisible = true;
      this.$nextTick(() => {
        var iframe = document.getElementById("jobEditIframe");
        iframe.src = "";
        iframe.src = `https://m.${
          window.location.href.indexOf("topnews.cn") >= 0
            ? "topnews.cn"
            : "dingnews.net"
        }/recruit-h5/index.html#/pages/job-detail/index?token=${localStorage.getItem(
          "token"
        )}&id=${item.id}&lng=${item.location_lng}&lat=${item.location_lat}`;
      });
    },
    editJob(item) {
      this.jogDialogVisible = true;
      this.$nextTick(() => {
        var iframe = document.getElementById("jobEditIframe");
        iframe.src = "";
        iframe.src = `https://m.${
          window.location.href.indexOf("topnews.cn") >= 0
            ? "topnews.cn"
            : "dingnews.net"
        }/recruit-h5/index.html#/pages/post-job/index?token=${localStorage.getItem(
          "token"
        )}&id=${item.id}`;
      });
    },
    openJob(item) {
      if (item.status_msg == "已招满") {
        this.$axios
          .get(`${RECRUIT_HOST}/api/recruit/checkStatus?id=${item.id}`)
          .then((res) => {
            if (res.data.code == 0) {
              this.$message({
                type: "success",
                message: "操作成功!",
              });

              this.getJobList();
            } else {
              this.$message.error(res.data.msg);
            }
          });
      } else {
        this.$confirm("确定要关闭该职位信息吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$axios
              .get(`${RECRUIT_HOST}/api/recruit/checkStatus?id=${item.id}`)
              .then((res) => {
                if (res.data.code == 0) {
                  this.$message({
                    type: "success",
                    message: "操作成功!",
                  });

                  this.getJobList();
                } else {
                  this.$message.error(res.data.msg);
                }
              });
          })
          .catch(() => {});
      }
    },
    deleteJob(item) {
      this.$confirm("确定要删除该职位信息吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .get(`${RECRUIT_HOST}/api/recruit/delete?id=${item.id}`)
            .then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });

                this.getJobList();
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.mainContainer {
  min-width: 1000px;
  min-height: 100%;

  .waitContain {
    border-radius: 8px;
    background-color: #fff;
    padding: 10vh 59px 100px 99px;
    display: flex;
    height: calc(100vh - 100px);

    .textContain {
      flex: 1;
      padding-right: 96px;

      .title {
        color: #f32432;
        font-family: "PingFang SC";
        font-size: 48px;
        font-weight: 600;
        line-height: 110px;
      }

      .label {
        color: #333333;
        font-family: "PingFang SC";
        font-size: 18px;
        font-weight: 500;
        line-height: 25px;
        margin-top: 23px;
      }

      .intro {
        color: #666666;
        text-align: justify;
        font-family: "PingFang SC";
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        margin-top: 16px;
      }

      .addBtn {
        width: 112px;
        line-height: 36px;
        border-radius: 4px;
        background: #f32432;
        color: #ffffff;
        text-align: center;
        font-family: "PingFang SC";
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        margin-top: 74px;
      }
    }

    .exampleImg {
      width: 58%;
      height: fit-content;
    }

    /deep/.contactContainer {
      .el-dialog__body {
        padding-bottom: 32px;
        padding-top: 12px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .contactImg {
          width: 64px;
          margin: 0 auto 17px auto;
        }

        .contactText {
          color: #333333;
          text-align: center;
          font-family: "PingFang SC";
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          display: flex;
        }
      }

      .submitBtn {
        width: 80px;
        border: 1px solid #dcdfe6;
        cursor: pointer;
        text-align: center;
        font-size: 14px;
        border-radius: 4px;
        color: #333;
        line-height: 36px;
        display: inline-block;
        margin-left: 12px;
      }

      .submitBtn[type="primary"] {
        width: 80px;
        background-color: #ea0e0e;
        border-color: #ea0e0e;
        color: #fff;
      }

      .dialog-footer {
        display: flex;
        justify-content: center;
      }
    }
  }

  .setContain {
    height: calc(100vh - 100px);
    border-radius: 8px;
    background: #fff;
    position: relative;

    /deep/.el-tabs {
      .el-tabs__header {
        margin-bottom: 0;
      }

      .el-tabs__nav-wrap {
        padding-left: 32px;
      }

      .el-tabs__nav-wrap::after {
        background: #edf1f8;
        height: 1px;
      }

      .el-tab-pane {
        height: calc(100vh - 145px);
        overflow-y: auto;
      }

      .el-tabs__item {
        height: 45px;
        line-height: 45px;
      }
    }

    .userInfoContain {
      width: 100%;
      padding: 20px 32px 52px 32px;

      .userInfoNavContain {
        display: flex;

        .userInfoNav {
          width: 80px;
          border-radius: 8px;
          border: 1px solid #eeeeeecc;
          color: #333333;
          font-family: "PingFang SC";
          font-size: 14px;
          font-weight: 400;
          line-height: 32px;
          text-align: center;
          margin-right: 12px;
          cursor: pointer;
        }

        .userInfoActive {
          background: #ffe6e6;
          border: 0;
          color: #f32432;
        }
      }

      .userHomeInfoAlert {
        color: #f59a23;
        font-family: "PingFang SC";
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        margin-top: 20px;
      }

      .userInfoTitleContain {
        width: 456px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;

        .userInfoTitle {
          color: #333333;
          font-family: "PingFang SC";
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
        }

        .userInfoMore {
          color: #999999;
          font-family: "PingFang SC";
          font-size: 12px;
          font-weight: 400;
          cursor: pointer;
        }
      }

      /deep/.el-input {
        border-radius: 2px;
        width: 456px;
        height: 36px;
        margin-top: 7px;

        .el-input__inner {
          border: 0;
          background: #f6f7f9;
          color: #333333;
          font-family: "PingFang SC";
          font-size: 14px;
          font-weight: 400;
        }
      }

      .userInfoAlert {
        width: 456px;
        color: #999999;
        font-family: "PingFang SC";
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        margin-top: 4px;
      }

      .userLogoContain {
        width: 80px;
        height: 80px;
        margin-top: 8px;

        .userLogo {
          width: 80px;
          height: 80px;
          border-radius: 4px;
          cursor: pointer;
          object-fit: cover;
        }
      }

      /deep/.el-textarea {
        border-radius: 2px;
        width: 456px;
        margin-top: 9px;

        .el-textarea__inner {
          background: #f6f7f9;
          border: 0;
          padding: 8px 12px;
          color: #666666;
          font-family: "PingFang SC";
          font-size: 14px;
          font-weight: 400;
          line-height: 21px;
          min-height: 58px !important;
        }

        .el-input__count {
          background: #f6f7f9;
        }
      }

      .userInfoSubmitBtn {
        width: 112px;
        flex-shrink: 0;
        border-radius: 4px;
        background: #f32432;
        color: #ffffff;
        text-align: center;
        font-family: "PingFang SC";
        font-size: 14px;
        font-weight: 500;
        line-height: 36px;
        cursor: pointer;
        margin-top: 57px;
      }

      .userInfoExamineContain {
        display: flex;
        margin-top: 11vh;

        .userInfoExamineTitle {
          width: 112px;
          line-height: 36px;
          border-radius: 4px;
          background: #f5f5f5;
          color: #ff99aa;
          text-align: center;
          font-family: "PingFang SC";
          font-size: 14px;
          font-weight: 500;
          margin-right: 16px;
        }

        .userInfoExaminecancel {
          width: 112px;
          flex-shrink: 0;
          border-radius: 4px;
          background: #f32432;
          color: #ffffff;
          text-align: center;
          font-family: "PingFang SC";
          font-size: 14px;
          font-weight: 500;
          line-height: 36px;
          cursor: pointer;
        }
      }

      .userInfoSubmitAlert {
        width: 456px;
        color: #999999;
        font-family: "PingFang SC";
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        margin-top: 8px;
      }

      .userInfoExamineAlert {
        width: 456px;
        color: #f32432;
        font-family: "PingFang SC";
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        margin-top: 8px;
      }

      .userHomeInfoEditContain {
        width: 520px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .homeBgContain {
        width: 160px;
        position: relative;
        margin-top: 8px;
        cursor: pointer;

        .homeBg {
          width: 160px;
          height: 90px;
          border-radius: 4px;
          object-fit: cover;
        }

        .imgDelete {
          height: 16px;
          position: absolute;
          top: 0;
          right: 0;
        }
      }

      .homeBgAlert {
        width: 256px;
        color: #999999;
        font-family: "PingFang SC";
        font-size: 12px;
        font-weight: 400;
        line-height: 17px;
        margin-top: 7px;
      }

      .searchKeyContain {
        padding-top: 4px;

        .searchInputContain {
          width: 343px;
          height: 36px;
          border-radius: 4px;
          background-color: #f2f3f5;
          display: flex;
          align-items: center;
          padding: 0 12px;
          margin-top: 8px;

          .keyIcon {
            height: 16px;
            margin-right: 4px;
            cursor: pointer;
          }

          /deep/.el-input {
            height: 36px;
            background-color: #f2f3f5;
            margin: 0;

            .el-input__inner {
              height: 36px !important;
              line-height: 36px !important;
              background-color: #f2f3f5;
              padding: 0;
              color: #000000;
              font-family: "PingFang SC";
              font-size: 14px;
              font-weight: 400;
            }
          }

          .keyText {
            color: #999999;
            font-family: "PingFang SC";
            font-size: 14px;
            font-weight: 400;
          }
        }
      }

      /deep/.uploadElemBox {
        .el-upload-dragger {
          border: 0;
          width: fit-content;
          height: fit-content;
        }

        .el-upload-list {
          display: none;
        }
      }
    }

    .contentSetContain {
      flex: 1;
      padding: 20px 32px 24px 32px;
      overflow-y: hidden;
      background: #fff;

      .contentSetTitle {
        color: #333333;
        font-family: "PingFang SC";
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 25px;
      }

      .contentSetAlert {
        color: #999999;
        font-family: "PingFang SC";
        font-size: 10px;
        font-weight: 400;
        line-height: 14px;
        margin-top: 8px;
        margin-bottom: 16px;
      }

      .contentSetInnerContain {
        display: flex;
        height: calc(100% - 63px);

        .menuContain {
          width: 307px;
          height: 100%;
          display: flex;
          flex-direction: column;
          padding-right: 32px;

          .addMenuBtn {
            width: 275px;
            height: 32px;
            border-radius: 4px;
            background-color: #f32432;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            .addMenuImg {
              height: 16px;
              margin-right: 8px;
            }

            .addMenuText {
              color: #ffffff;
              font-family: "PingFang SC";
              font-size: 14px;
              font-weight: 400;
            }
          }

          .menusContain {
            flex: 1;
            border-radius: 4px;
            background-color: #f4f5f9;
            padding: 20px;
            margin-top: 20px;
            overflow-y: auto;

            .menuItem {
              border-radius: 8px;
              background: #fff;
              display: flex;
              align-items: center;
              padding: 0 4px 0 12px;
              margin-bottom: 12px;
              cursor: pointer;

              .setImg {
                height: 16px;
                margin-right: 4px;
              }

              .menuName {
                color: #333333;
                font-family: "PingFang SC";
                font-size: 14px;
                font-weight: 400;
                line-height: 40px;
                flex: 1;
                padding-right: 4px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .menuEditBtn,
              .menuDelBtn {
                color: #999999;
                font-family: "PingFang SC";
                font-size: 12px;
                font-weight: 400;
                margin-right: 8px;
              }

              .acytiveText {
                color: #f32432;
              }
            }

            .active {
              background: #ffe6e6;

              .menuName {
                color: #f32432;
              }
            }
          }
        }

        .menuContentContain {
          flex: 1;
          padding-left: 27px;
          border-left: 1px solid #eeeeee;

          .menuContentTitleContain {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .menuContentTitle {
              color: #333333;
              font-family: "PingFang SC";
              font-size: 14px;
              font-weight: 500;
              line-height: 32px;
            }

            .addNewsBtn {
              width: 100px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 4px;
              background-color: #f32432;
              cursor: pointer;

              .addNewsImg {
                height: 16px;
                margin-right: 4px;
              }

              .addNewsText {
                color: #ffffff;
                font-family: "PingFang SC";
                font-size: 14px;
                font-weight: 400;
                line-height: 32px;
              }
            }
          }

          .paramsContain {
            .paramInfo {
              color: #666666;
              font-family: "PingFang SC";
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
              margin-top: 20px;

              .paramInfoLabel {
                color: #333333;
              }
            }
          }

          .newsContain {
            height: calc(100% - 52px);
            overflow-y: auto;
            margin-top: 20px;
            padding-right: 10px;

            .newsItem {
              padding: 8px 0;
              display: flex;
              height: 110px;
              box-sizing: content-box;
              border-bottom: 1px solid #eeeeee;
              align-items: center;

              &:last-child {
                border-bottom: 0;
              }

              .shiftImg {
                height: 16px;
                margin-right: 20px;
                cursor: pointer;
              }

              .bgContainer {
                width: calc(100% - 29px);
                display: flex;
                padding: 10px;
                border-radius: 5px;
              }

              .cover-container {
                width: 160px;
                height: 90px;
                border-radius: 6px;
                overflow: hidden;
                background: #ccc;
                margin-right: 16px;
                flex-shrink: 0;

                .cover {
                  height: 100%;
                  width: 100%;
                }
              }

              .info-box {
                flex: 1;
                position: relative;
                width: calc(100% - 210px);

                .titleContainer {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  margin-bottom: 44px;
                }

                .title {
                  flex: 1;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 1;
                  overflow: hidden;
                  color: #333333;
                  font-family: "PingFang SC";
                  font-size: 18px;
                  font-weight: 500;
                  line-height: 25px;
                  padding-right: 15px;
                }
              }

              .create-time {
                color: #999999;
                font-family: "PingFang SC";
                font-size: 14px;
                font-weight: 400;
                line-height: 21px;
              }

              .action-bar {
                display: flex;
                justify-content: flex-end;

                .countInfo {
                  color: #999999;
                  font-family: "PingFang SC";
                  font-size: 14px;
                  font-weight: 400;
                  line-height: 21px;
                  margin-right: 14px;
                  display: inline-block;
                }

                .menuNewsDelBtn {
                  color: #4876ff;
                  font-family: "PingFang SC";
                  font-size: 14px;
                  font-weight: 400;
                  line-height: 21px;
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
    }

    /deep/.editMenuContainer {
      .el-dialog__body {
        padding-bottom: 32px;
        padding-top: 12px;
        padding-left: 32px;

        .editMenuInnerContain {
          .editItem {
            display: flex;
            align-items: center;
            margin-bottom: 24px;

            .label {
              width: 96px;
              flex-shrink: 0;
              color: #333333;
              font-family: "PingFang SC";
              font-size: 14px;
              font-weight: 500;

              .require {
                color: #f32432;
              }
            }

            .el-input {
              margin-bottom: 0;
            }

            .el-input__inner {
              width: 452px;
              border-radius: 2px;
              background: #f6f7f9;
              border: 0;
              height: 36px;
              color: #333;
              font-family: "PingFang SC";
              font-size: 14px;
              font-weight: 400;
            }
          }
        }
      }

      .submitBtn {
        width: 80px;
        border: 1px solid #dcdfe6;
        cursor: pointer;
        text-align: center;
        font-size: 14px;
        border-radius: 4px;
        color: #333;
        line-height: 36px;
        display: inline-block;
        margin-left: 12px;
      }

      .submitBtn[type="primary"] {
        width: 80px;
        background-color: #ea0e0e;
        border-color: #ea0e0e;
        color: #fff;
      }
    }

    /deep/.collectionAddContainer {
      .el-dialog {
        height: 86vh;

        .el-dialog__body {
          padding-top: 10px;
        }

        .collectionAddKeyword {
          width: 350px;
          margin-bottom: 15px;
        }

        .searchNoDataContainer {
          width: 100%;
          height: calc(86vh - 245px);
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;

          .noDataText {
            margin-top: 21px;
            font-size: 20px;
            color: rgb(204, 204, 204);
          }
        }

        .videoCollectContainer {
          width: 100%;
          height: calc(86vh - 245px);
          overflow-y: auto;
          padding-right: 10px;

          .scriptListItem {
            padding: 8px 0;
            display: flex;
            height: 110px;
            box-sizing: content-box;
            border-bottom: 1px solid #eeeeee;

            &:last-child {
              border-bottom: 0;
            }

            .el-checkbox {
              margin: 0 10px 0 0;
              display: flex;
              align-items: center;
            }

            .bgContainer {
              width: calc(100% - 29px);
              display: flex;
              padding: 10px;
              border-radius: 5px;
            }

            .cover-container {
              width: 160px;
              height: 90px;
              border-radius: 6px;
              overflow: hidden;
              background: #ccc;
              margin-right: 16px;
              flex-shrink: 0;

              .cover {
                height: 100%;
                width: 100%;
              }
            }

            .info-box {
              flex: 1;
              position: relative;
              width: calc(100% - 210px);

              .titleContainer {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 44px;
              }

              .title {
                flex: 1;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
                color: #333333;
                font-family: "PingFang SC";
                font-size: 18px;
                font-weight: 500;
                line-height: 25px;
                padding-right: 15px;
                cursor: pointer;
              }
            }

            .create-time {
              color: #999999;
              font-family: "PingFang SC";
              font-size: 14px;
              font-weight: 400;
              line-height: 21px;
            }

            .action-bar {
              display: flex;

              .countInfo {
                color: #999999;
                font-family: "PingFang SC";
                font-size: 14px;
                font-weight: 400;
                line-height: 21px;
                margin-right: 14px;
                display: inline-block;
              }
            }
          }
        }

        .el-dialog__footer {
          margin-top: 10px;
        }
      }
    }

    .noJobContain {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .noJobText {
        color: #333333;
        text-align: center;
        font-family: "PingFang SC";
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        margin-top: -90px;
      }

      .pubJobBtn {
        width: 122px;
        border-radius: 4px;
        background: #ea0e0e;
        color: #ffffff;
        text-align: center;
        font-family: "PingFang SC";
        font-size: 14px;
        font-weight: 500;
        line-height: 36px;
        margin-top: 24px;
        cursor: pointer;
      }
    }

    .jobManageContain {
      padding: 20px 32px;

      .el-input {
        width: 220px;
      }

      .jobTypeContain {
        display: flex;
        align-items: center;
        padding-top: 10px;

        .jobTypeItem {
          color: #333333;
          font-family: "PingFang SC";
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          margin-right: 32px;
          cursor: pointer;
        }

        .jobTypeActive {
          color: #ea0e0e;
        }
      }

      .jobList {
        .jobItem {
          padding: 20px 0;
          border-bottom: 1px solid #edf1f8;

          .jobFlex {
            display: flex;
            align-items: center;
          }

          .jobHeader {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .jobName {
              color: #333333;
              font-family: "PingFang SC";
              font-size: 16px;
              font-weight: 400;
              line-height: 22px;
              margin-right: 24px;
              cursor: pointer;
            }

            .jobMoney {
              color: #ea0e0e;
              font-family: "PingFang SC";
              font-size: 16px;
              font-weight: 500;
              line-height: 22px;
            }

            .jobStatus {
              color: #35d535;
              font-family: "PingFang SC";
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
            }

            .jobStatusIng {
              color: #008fff;
            }

            .jobStatusClosed {
              color: #999999;
            }

            .jobStatusFail {
              color: #d80c18;
            }

            .jobTime {
              color: #999999;
              font-family: "PingFang SC";
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
              margin-left: 24px;
            }
          }

          .jobTagContain {
            display: flex;
            flex-wrap: wrap;

            .jobTag {
              margin: 8px 6px 0 0;
              border-radius: 4px;
              background: #f8f8f8;
              padding: 0 6px;
              color: #666666;
              font-family: "PingFang SC";
              font-size: 12px;
              font-weight: 400;
              line-height: 24px;
            }
          }

          .jobFooter {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;

            .jobStatus {
              border-radius: 4px;
              background: #eaffea;
              padding: 0 12px;
              color: #35d535;
              font-family: "PingFang SC";
              font-size: 12px;
              font-weight: 400;
              line-height: 24px;
              margin-right: 24px;
            }

            .jobStatusIng {
              background: #eef7ff;
              color: #008fff;
            }

            .jobView {
              color: #999999;
              font-family: "PingFang SC";
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;

              .jobViewNum {
                color: #666666;
              }
            }

            .jobBtn {
              color: #5574e7;
              font-family: "PingFang SC";
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
              margin-left: 28px;
              cursor: pointer;
            }

            .jobReason {
              border-radius: 4px;
              background: #fdf3f3;
              padding: 0 12px;
              color: #d80c18;
              font-family: "PingFang SC";
              font-size: 12px;
              font-weight: 400;
              line-height: 24px;
            }
          }
        }

        .jobClosed {
          .jobName,
          .jobMoney,
          .jobTag {
            color: #999999 !important;
          }
        }
      }

      .noJob {
        color: #333333;
        text-align: center;
        font-family: "PingFang SC";
        font-size: 16px;
        font-weight: 400;
        line-height: 220px;
        margin-top: 50px;

        .noJobSearch {
          color: #d80c18;
        }
      }
    }

    .openJobBtn {
      width: 82px;
      border-radius: 4px;
      background: #ea0e0e;
      color: #ffffff;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 12px;
      font-weight: 500;
      line-height: 29px;
      cursor: pointer;
      position: absolute;
      right: 32px;
      top: 8px;
    }
  }

  .authenticationContainer {
    /deep/.el-dialog {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      margin: 0 !important;

      .el-dialog__body {
        padding-top: 14px;
      }

      .imgStepContain {
        color: #666666;
        font-family: "PingFang SC";
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      }

      .imgStepContain {
        border-radius: 6px;
        border: 1px solid #dcdfe6;
        padding: 22px 32px 0 32px;
        margin-top: 20px;

        .noAuthenticationContain {
          display: flex;
          border-bottom: 1px solid #dcdfe6;
          margin-bottom: 22px;
        }

        .authenticationStepTitle {
          color: #333333;
          font-family: "PingFang SC";
          font-size: 16px;
          font-weight: 500;
          line-height: 22px;
        }

        .authenticationStepIntro {
          color: #333333;
          font-family: "PingFang SC";
          font-size: 16px;
          font-weight: 400;
          line-height: 22px;
          margin-top: 10px;
        }
      }
    }
  }

  .jobEditContain {
    /deep/.el-dialog__header {
      padding: 0;
    }

    /deep/.el-dialog__body {
      padding-top: 10px;
      padding-bottom: 15px;
    }

    /deep/.el-dialog__headerbtn {
      top: 5px;
      right: 5px;
    }
  }
}
</style>
